/* eslint-disable yoda */
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter
} from '@ps-design-system/components/Dialog';
import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';

import { useUploadModal } from '../context/UploadModalContext';
import { useUploaderActions } from '../hooks/useUploaderActions';

const UploaderDeleteModal = () => {
  const { openDelete, closeDeleteModal, itemToDelete } = useUploadModal();
  const { handleDelete } = useUploaderActions();

  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      closeDeleteModal();
    }
  };

  const handleDeleteMedia = useCallback(() => {
    if (itemToDelete) {
      handleDelete(itemToDelete);
      closeDeleteModal();
    }
  }, [handleDelete, closeDeleteModal, itemToDelete]);

  const handleCancel = () => {
    closeDeleteModal();
  };

  return (
    <Dialog open={openDelete} onOpenChange={handleOpenChange} >
      <DialogContent
        size="lg"
        className="uploader-delete-modal-content"
      >
        <DialogHeader headerAlignment="left">
          <DialogTitle className="uploader-dialog-header">
            <FormattedMessage id="uploader.delete_modal.remove" defaultMessage="Remove this media?" />
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text typeface="body-2">
            <FormattedMessage id="uploader.delete_modal.description" defaultMessage="Are you sure you want to delete this? You won’t be able to undo this and would need to upload again." />
          </Text>
        </DialogBody>
        <DialogFooter className="add-dialog-footer">
          <div className="add-footer">
            <div>
              <Button
                variant="underline"
                onClick={handleCancel}
              >
                <FormattedMessage id="uploader.delete_modal.cancel" defaultMessage="Cancel" />
              </Button>
            </div>
            <div className="add-footer-button">
              <Button onClick={handleDeleteMedia}>
                <FormattedMessage id="uploader.delete_modal.yes" defaultMessage="Yes, delete it" />
              </Button>
            </div>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UploaderDeleteModal;
